import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { FolderType } from '../constants';

interface UseLogClickSortParams {
  sortType: string;
  folderType: FolderType;
}

export const useLogClickSort = ({
  sortType,
  folderType,
}: UseLogClickSortParams) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({
      name: 'CLICK_SORT',
      analytics: {
        SORT_TYPE: sortType,
        FOLDER_TYPE: folderType,
      },
    });
  }, [logAnalyticsEvent, sortType, folderType]);
};
